<template>
	<div class="icon-style-editor flex-space-between--center">
		<template v-if="nativeEditor">
			<EmojiPicker title="Choose Icon" :iconStyle.sync="localIconStyle" :readonly="readonly" />
		</template>
		<template v-else>
			<IconPicker title="Choose Icon" :iconStyle.sync="localIconStyle" :readonly="readonly" />
			<ColorPicker
				v-if="allowColor && !readonly"
				title="Icon Color"
				:color.sync="localIconStyle.fillColor"
				:iconName="'background-sample-icon'"
				:disabled="['ply-element-transparent', 'ply-element-default-icon'].includes(localIconStyle.name) || readonly"
			/>
		</template>
	</div>
</template>

<script>
import { isEqual } from 'lodash';

import ColorPicker from '@/components/common/ColorPicker/ColorPicker';
import IconPicker from '../IconPicker';
import EmojiPicker from '../EmojiPicker';

export default {
	name: 'IconStyleEditor',
	components: {
		ColorPicker,
		IconPicker,
		EmojiPicker,
	},

	props: {
		btnSettings: { type: Object },
		nativeEditor: { type: Boolean, default: false },
		allowColor: { type: Boolean, default: true },
		readonly: { type: Boolean, default: false },
	},
	watch: {
		localIconStyle: {
			handler() {
				const newV = JSON.parse(JSON.stringify({ ...this.btnSettings, icon: this.localIconStyle, local: this.localIconStyle || false }));
				this.$emit('update:btnSettings', newV);
			},
			deep: true,
		},
		btnSettings: {
			handler(newV) {
				if (!isEqual(newV.icon, this.localIconStyle)) {
					this.localIconStyle = JSON.parse(JSON.stringify(newV.icon));
				}
			},
			deep: true,
		},
	},

	mounted() {
		this.localIconStyle = JSON.parse(JSON.stringify(this.btnSettings.icon));
	},
	data: () => ({
		localIconStyle: {
			name: null,
			size: 12,
		},
	}),
};
</script>

<style scoped lang="scss">
.icon-style-editor {
	> div:not(:last-child) {
		margin: 0 10px 0 0;
	}

	.right-side {
		width: 80px;
	}
}
</style>
